/**
 * Requests of the open API workspace: `requests:` / `r:` / `request:` / `req:` — name, method, the URL without credentials. Desktop only.
 * Backed by the local search index (PLAN §12.2) through `deps.client`
 * (`index/indexClient.js` on desktop, `index/webIndexClient.js` on web).
 */
import { Send } from 'lucide-react';
import { useCollectionsStore } from '../../store/collectionsStore';
import { createIndexProvider } from '../index/indexProvider';

export const SPEC = Object.freeze({ id: 'requests', kinds: ['request'], prefixes: ['requests', 'r', 'request', 'req'], labelKey: 'palette.scope.requests', icon: Send, order: 80, page: 'collections', desktopOnly: true, workspaceScoped: true, parentKind: 'collection', apiClient: true });

/** @param {{ client: object }} deps */
export default function create(deps) {
  const getCollectionName = (id) =>
    (useCollectionsStore.getState().collections || []).find((c) => String(c.id) === String(id))?.name || undefined;
  return createIndexProvider(SPEC, { getCollectionName, ...deps });
}
